<template>
    <div class="logo-container">
      <img :src="brandImagePath" v-if="brandImagePath" :style="brandImageWidth">
    </div>
</template>

<script>
export default {
  name: 'ProductLabel',
  props: ['product'],
  computed: {
    brandImagePath(){
      let brandName = this.product.brand_name.toLowerCase().replace(/ +/, '');
      if(['fillinn', 'jonnesway', 'thorvik', 'ombra', 'carbon', 'rotake'].indexOf(brandName) > -1){
        return '/images/pride-logos/' + this.product.brand_name.toLowerCase().replace(/ +/, '') + '.svg';
      }
      return null;
    },
    brandImageWidth(){
      let brandName = this.product.brand_name.toLowerCase().replace(/ +/, '');
      if(['fillinn', 'jonnesway', 'thorvik', 'ombra', 'carbon', 'rotake'].indexOf(brandName) > -1){
        switch (brandName){
          case 'fillinn':
            return 'max-width: 25%';
          case 'jonnesway':
            return 'max-width: 45%';
          case 'rotake':
            return 'max-width: 31%';
          case 'carbon':
            return 'max-width: 41%';
          case 'thorvik':
            return 'max-width: 35%';
          case 'ombra':
            return 'max-width: 28%';
        }
      }
      return null;
    }
  }
}
</script>

<style scoped>
  .logo-container {
    width: 100%;
    text-align: right;
    height: 50px;

  }

  .logo-container img {
    max-height: 46px;
    padding: 2px 0;
    display: inline-block;
    margin-top: 10px;
  }
</style>
